/**
 * @flow
 */
import styled from 'react-emotion'
import { mobile, tablet, desktop } from '../../../utils/mixins'
import Colors from '../../../themes/Colors'

export const MapSectionContainer = styled('div')`
  display: flex;
  background-color: ${props =>
    props.isNewArcadePage ? Colors.darkTwoDefault : Colors.blackDefault};
  width: 100%;
  ${mobile} {
    font-size: 14px;
    flex-direction: column;
  }
  ${tablet} {
    font-size: 16px;
    flex-direction: column;
  }
  ${desktop} {
    font-size: 16px;
  }
`

export const MapSectionResponsiveContainer = styled('div')`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: auto;
  ${mobile} {
    flex-direction: column;
  }
  ${tablet} {
    flex-direction: column;
  }
  ${desktop} {
    max-width: 78.5em;
  }
`
export const MapBackground = styled('iframe')`
  width: auto;
  height: auto;
  flex: 1;
  ${mobile} {
    min-height: 360px;
  }
  ${tablet} {
    min-height: 360px;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/MapSection/styledComponents.js